import { render, staticRenderFns } from "./MessageRendererDemo.vue?vue&type=template&id=0f33ae9e&scoped=true"
import script from "./MessageRendererDemo.vue?vue&type=script&lang=js"
export * from "./MessageRendererDemo.vue?vue&type=script&lang=js"
import style0 from "./MessageRendererDemo.vue?vue&type=style&index=0&id=0f33ae9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33ae9e",
  null
  
)

export default component.exports